
import { defineComponent } from 'vue';
import { computed } from '@vue/runtime-core';
import { Actions, formFieldsStore, Getters } from '@/store';
import { useStore } from 'vuex';

import ModalHeader from '@/modules/modals/components/ModalHeader.vue';
import ModalBody from '@/modules/modals/components/ModalBody.vue';
import ModalFooter from '@/modules/modals/components/ModalFooter.vue';
import Loader from '@/components/Loader.vue';

import ModalService from '@/modules/modals/services/modalService';
import FormsService from '@/services/2.6/FormsService';
import WebEnvConfigService from '@/services/TheWebEnvConfigService';
import { IDataPoints, IDataPointsAddFields } from '@/models/AdditionalFields';

import Multiselect from '@vueform/multiselect';
import WebEnvConfig from '@/models/WebEnvConfig';

import CompDataFeedsRequest from '@/store/2.6/models/CompDataFeedsRequest';
import theLocalStorageUtils from '@/utils/LocalStorageUtils';
import { LocalStorageKeys } from '@/constants/LocalStorageKeys';
import _ from 'lodash';

let webEnvConfig: WebEnvConfig;
let formCode: string;

export default defineComponent({
    components: { ModalHeader, ModalBody, Multiselect, ModalFooter, Loader },
    data() {
        return {
            modal: null,
            dataAdditionalFields: {} as IDataPointsAddFields,
            isLoading: false,
        };
    },
    setup() {
        const store = useStore();
        const delimeterOptions: string[] = [';', ',', '/'];
        return {
            store,
            delimeterOptions,
        };
    },
    async beforeMount() {
        this.dataAdditionalFields = _.cloneDeep(formFieldsStore.AdditionalFields) as IDataPointsAddFields;

        for (let i = 0; i < this.dataAdditionalFields.additionalFields.length; i++) {
            if (this.dataAdditionalFields.additionalFields[i].delimiter === null) this.dataAdditionalFields.additionalFields[i].delimiter = this.delimeterOptions[0];
            if (this.dataAdditionalFields.additionalFields[i].dataPoints === null) continue;
            this.dataAdditionalFields.additionalFields[i].selected = this.dataAdditionalFields.additionalFields[i].dataPoints.map((a) => a.name);
        }
    },
    mounted() {
        const modalElement = this.$refs.additionalFields;
        this.modal = ModalService.initialize(modalElement, this);
        ModalService.size(modalElement, 'lg');
        ModalService.open(this.modal);
    },
    methods: {
        captureChange(items: string[], index: number) {
            let addFieldValue: IDataPoints[] = [];
            let lookup: any = [];
            for (let i = 0; i < items.length; i++) {
                lookup = this.dataAdditionalFields.dataPoints.find((obj) => obj.name === items[i]);
                addFieldValue.push(lookup);
            }
            this.dataAdditionalFields.additionalFields[index].dataPoints = addFieldValue;
        },
        async saveChanges() {
            this.isLoading = true;

            await formFieldsStore.saveAdditionalFields({
                data: this.dataAdditionalFields.additionalFields,
                formId: theLocalStorageUtils.get(LocalStorageKeys.formCode),
            });

            const compsData = computed(() => this.store.getters[Getters.CompAddresses.Comps]);
            const comps = compsData.value;

            for (const idx in comps) {
                const feedsRequest: CompDataFeedsRequest = {
                    address: comps[idx].address,
                    qsGuid: comps[idx].qsGuid,
                    formCode: theLocalStorageUtils.get(LocalStorageKeys.formCode) ?? '',
                    compsGuid: theLocalStorageUtils.get(LocalStorageKeys.almCompId) ?? '',
                    isSubject: false,
                    fetch: ['pr'],
                };
                await this.store.dispatch(Actions.CompAddresses.FetchCompDataFeeds, feedsRequest);
            }
            this.isLoading = false;
            ModalService.hide(this.modal);
        },
        async configure() {
            webEnvConfig = await WebEnvConfigService.getInstance().getConfigByHost();
            const formResult = computed(() => this.store.getters[Getters.CompAddresses.ActiveFormCode]);
            formCode = formResult.value;
        },
    },
});
